<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_funcionario_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Funcionarios</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="tipo_documento" class="col-md-5"
                      >Tipo de Documento</label
                    >
                    <select
                      id="tipo_documento"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_documento"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_documento in listasForms.tipo_identificacion"
                        :key="tipo_documento.numeracion"
                        :value="tipo_documento.numeracion"
                      >
                        {{ tipo_documento.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="numero_documento" class="col-md-5"
                      >Numero de Documento</label
                    >
                    <input
                      type="number"
                      id="numero_documento"
                      v-model="filtros.numero_documento"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="nombres" class="col-md-5">Nombres</label>
                    <input
                      type="text"
                      id="nombres"
                      v-model="filtros.nombres"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="representante" class="col-md-5"
                      >Apellidos</label
                    >
                    <input
                      type="text"
                      id="apellidos"
                      v-model="filtros.apellidos"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="email" class="col-md-5"> Email</label>
                    <input
                      type="text"
                      id="email"
                      v-model="filtros.email"
                      class="col-md-7"
                    />
                  </div>
									<div class="form-group row">
                    <label for="tipo_sangre" class="col-md-5"
                      >Tipo de Sangre</label
                    >
                    <select
                      id="tipo_sangre"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_sangre"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_sangre in listasForms.tipo_sangres"
                        :key="tipo_sangre.numeracion"
                        :value="tipo_sangre.numeracion"
                      >
                        {{ tipo_sangre.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="estado" class="col-md-5"> Estado</label>
                    <select
                      id="estado"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="area" class="col-md-5">Area</label>
                    <select
                      id="area"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.area"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="are in listasForms.tipos_area"
                        :key="are.numeracion"
                        :value="are.numeracion"
                      >
                        {{ are.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="cargo" class="col-md-5">Cargo</label
                    >
                    <select
                      id="cargo"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.cargo"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="carg in listasForms.tipos_cargo"
                        :key="carg.numeracion"
                        :value="carg.numeracion"
                      >
                        {{ carg.descripcion }}
                      </option>
                    </select>
                  </div>
                  
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_documento1"
                              v-model="form.tipo_documento"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_documento1"
                              >Tipo de Documento</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="numero_documento1"
                              v-model="form.numero_documento"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="numero_documento1"
                              >Numero de Documento</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombres1"
                              v-model="form.nombres"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="nombres1"
                              >Nombres</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="apellidos1"
                              v-model="form.apellidos"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="apellidos1"
                              >Apellidos</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="email1"
                              v-model="form.email"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="email1"
                              >Email</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="celular_principal"
                              v-model="form.celular_principal"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="celular_principal"
                              >Celular Principal</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="celular_alterno"
                              v-model="form.celular_alterno"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="celular_alterno"
                              >Celular Alterno</label
                            >
                          </div>
                        </div>
												<div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_sangre1"
                              v-model="form.tipo_sangre"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_sangre1"
                              >Tipo de Sangre</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="edad"
                              v-model="form.edad"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="edad"
                              >Edad</label
                            >
                          </div>
                        </div>        
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="area1"
                              v-model="form.area"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="area1"
                              >Area</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="cargo1"
                              v-model="form.cargo"
                              class="custom-control-input"
                            />
                            <label 
															class="custom-control-label"
															for="cargo1"
                              >Cargo</label
                            >
                          </div>
                        </div>                        
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_reactivacion"
                              v-model="form.fecha_reactivacion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fecha_reactivacion"
                              >Fecha de Reactivación</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_creacion"
                              v-model="form.fecha_creacion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fecha_creacion"
                              >Fecha Creación</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_modificacion"
                              v-model="form.fecha_modificacion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fecha_modificacion"
                              >Fecha Modificación</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExce()"
                v-if="$store.getters.can('admin.funcionarios.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "FuncionarioExport", //llegada tambien
  //components: { vSelect },
  components: { 
    Loading,
    },
  data() {
    return {
      cargando: false,
      form: {
        tipo_documento: true,
        numero_documento: true,
        nombres: true,
        apellidos: true,
        email: true,
        celular_principal: true,
        celular_alterno: true,
        tipo_sangre: true,
        edad: true,
        area: true,
        cargo: true,
        fecha_reactivacion: true,
        fecha_creacion: true,
        fecha_modificacion: true,
      },

      filtros: {
        tipo_documento: null,
        numero_documento: null,
        nombres: null,
        apellidos: null,
        email: null,
        tipo_sangre: null,
        estado: null,
        area: null,
        cargo: null,
      },

      listasForms: {
        tipo_identificacion: [],
        tipo_sangres: [],
        tipos_area: [],
        tipos_cargo: [],        
        estados: [],
      },
    };
  },

  methods: {
    getTiposIdentificacion() {
      axios.get("/api/lista/6").then((response) => {
        this.listasForms.tipo_identificacion = response.data;
      });
    },

    getTiposArea() {
      axios.get("/api/lista/77").then((response) => {
        this.listasForms.tipos_area = response.data;
      });
    },

    getTiposCargo() {
      axios.get("/api/lista/78").then((response) => {
        this.listasForms.tipos_cargo = response.data;
      });
    },

    getTipoSangres() {
      axios.get("/api/lista/16").then((response) => {
        this.listasForms.tipo_sangres = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    generarListadoExce() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/admin/funcionarios/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getTiposIdentificacion();
    await this.getTiposArea();
    await this.getTiposCargo();
    await this.getTipoSangres();
    await this.getEstados();
    this.cargando = false;
  },
};
</script>
